import React, {useEffect, useState, useRef, useCallback} from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, RadioGroup, Radio } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Divider from '@material-ui/core/Divider';
import { ValidatorForm, TextValidator} from 'react-material-ui-form-validator';
import { addSystemDrivers, addDriverInfo } from '../../actions/driverActions';
import MessageSnackbar from '../common/MessageSnackbar';

const useStyles = makeStyles((theme)=> ({
    dialogPaper: {
        minHeight: '80vh'
    }
}))



const SERVICE_NUMBER = 1;
const FULL_TIME_DRIVER = -1;
const SELF_EMPLOYEE_DRIVER = 0;
const DEFAULT_CITY_ID = 0;
const DEFAULT_ROLE = 0;             //self employee driver
const DEFAULT_QUANTITY = 1;         //self employee driver
const DEFAULT_WORKING_AREA = 0;
const DEFAULT_AUTHORITY = 0;        
const DEFAULT_GENDER = 0;           //MALE 
const DEFAULT_IS_HIRED = 1;         //hired
const DEFAULT_GROUP_CHECKED_ARR = [{id:1,checked: true},{id:3,checked: true}] //

function AddDriverInfo(props) {

    const classes = useStyles();
    const dispatch = useDispatch();

    const { openModal, onAddClose} = props;
    
    //get the basic info from the store, such as salary type , group type
    const cityList = useSelector(state => state.driver.cityList) || [];
    const [districtList,setDistrictList] = useState([]);
    
    const groupList = useSelector(state => state.driver.groupList) || [];
    const salaryTypeList = useSelector(state => state.driver.salaryTypeList);
    const salaryTypeFixList = useSelector(state => state.driver.salaryTypeFixList);

    const driverTypeList = useSelector(state => state.driver.driverTypeList);
    const genderList = useSelector(state => state.driver.genderList);
    const bossFlgList = useSelector(state => state.driver.bossFlgList);
    const workingAreaList = useSelector(state => state.driver.workingAreaList);
    const DEFAULT_SALARY_TYPE = useSelector(state => state.driver.DEFAULT_SALARY_TYPE);
    const DEFAULT_SALARY_TYPE_FIX = useSelector(state => state.driver.DEFAULT_SALARY_TYPE_FIX);

    // input params
    const [role,setRole] = useState(DEFAULT_ROLE);     //default self employee driver
    const [quantity,setQuantity] = useState(DEFAULT_QUANTITY);
    const [city,setCity] = useState(DEFAULT_CITY_ID);
    const [district,setDistrict] = useState();
    const [name,setName] = useState("");
    const [lastName,setLastName] = useState("");
    const [firstName,setFirstName] = useState("");
    const [phone,setPhone] = useState();
    const [workingArea,setWorkingArea] = useState(DEFAULT_WORKING_AREA);   //default
    const [address,setAddress] = useState("");
    const [sin,setSin] = useState();
    const [bossFlg,setBossFlg] = useState(DEFAULT_AUTHORITY);   //default 

    const [entryTime,setEntryTime] = useState(moment((new Date()).getTime()).unix());    
    const [resignationTime,setResignationTime] = useState(0);
    const [supplies,setSupplies] = useState("");    
    const [gender,setGender] = useState(DEFAULT_GENDER);     //default male
    const [isHired,setIsHired] = useState(DEFAULT_IS_HIRED);   //default hired
        
    const [driverGroupState, setDriverGroupState] = useState([]);
    //the radio button default selection should be "FIX" type
    const [driverSalaryTypeState,setDriverSalaryTypeState] = useState([]);
    //the default option value when the salary type is "FIX"
    const [salaryTypeFix, setSalaryTypeFix] = useState();


    //Todo:
    //Hard coding or tempory don't know
    const [roleDesc,setRoleDesc] = useState("");
    const [devicetoken,setDevicetoken] = useState("");    


    // to prevent the contious post , once submit , the action button will be disabled on seconds
    const [isSubmitted,setIsSubmitted] = useState(false);

    //parms used for MessageSnackbar which can notify the user the operation result
    const [msgShow,setMsgShow] = useState(false);
    const [msgLevel,setMsgLevel] = useState("info");    //"error" "warning" "info"  "success"
    const [msgContent,setMsgContent] = useState("");

    // operation status params
    const driverAddStatus = useSelector(state => state.driver.driverAddStatus) ;
    const driverAddRetMsg = useSelector(state => state.driver.driverAddRetMsg) ;
    //const driverAddError = useSelector(state => state.driver.driverAddError) ;

    /**
     * inital only once when mounted
     * assemble the group status and salary type
     * the group state default shoule be 1,3
     * the salary state default should be FIX and the value shoule be the first one of the list
     */
    useEffect(() => {
        let driverGroupList = [];
        groupList.map((item)=>{
            let isMatch = false;
            for (let index in DEFAULT_GROUP_CHECKED_ARR) {
                if (item.id === DEFAULT_GROUP_CHECKED_ARR[index].id) {
                    isMatch = true;
                    break;
                } 
            }
            if (isMatch) {
                driverGroupList.push({id: item.id, label: item.name, checked: true});
            } else {
                driverGroupList.push({id: item.id, label: item.name, checked: false});
            }            
        });
        setDriverGroupState(driverGroupList);

        let salaryGroupList = [];
        salaryTypeFixList.splice(0,salaryTypeFixList.length);
        salaryTypeList.map((item)=>{            
            if (item.value === DEFAULT_SALARY_TYPE) {
                salaryGroupList.push({id: item.id, label: item.value, checked: true});
                //setSalaryType(item.id);
                item.sub.map((ele,idx)=>{
                    salaryTypeFixList.push({label: ele.value, value: ele.id});
                    if (idx === 0) 
                        setSalaryTypeFix(ele.id);
                })
            } else {
                salaryGroupList.push({id: item.id, label: item.value, checked: false});
            }
        });
        setDriverSalaryTypeState(salaryGroupList);

    },[]);

    // dynamiclly assemble the district info when the city changes
    useEffect(() => {
        // districtList.push({label:'a',value:'a'});
        // districtList.splice(0,districtList.length);
        if (city !== null && city !== "") {            
            cityList.map((item)=>{                                
                if (item.id === city ) {
                    setDistrictList(item.district);
                }
            });            
        }
    },[city]);

    useEffect(() => {
        if (districtList !== null && districtList.length > 0) {
            setDistrict(districtList[0].district_id);            
        }
    },[districtList]);


    
    //show the result after user request a update or delete action    
    useEffect(() => {
        if (isSubmitted) {
            if (driverAddStatus === "FAIL") {
                showMessageSnackbar(true, "error", driverAddRetMsg + ", pls check and retry!");
            } else if (driverAddStatus === "SUCCESS") {
                showMessageSnackbar(true, "success","The driver Info was created! ");
                setTimeout(() =>handleClose(),2000);            
            } ;        
        }
    },[driverAddStatus]);
       
    return (        
            <Dialog 
                open={openModal}
                onClose={handleClose} 
                fullWidth={false}
                maxWidth='md'
                scroll='body'
            >
            <ValidatorForm onSubmit={handleAddDriverInfo}>
                <DialogTitle>
                Create a new driver
                </DialogTitle>
                <DialogContent dividers>
                    <div style={{display: 'flex', flexDirection: 'row', paddingBottom: 16}}>    
                        <TextField 
                            id="role"
                            select
                            label="driver type"
                            InputLabelProps={{ shrink: true }}
                            variant="outlined"
                            value={role} 
                            onChange={(e)=>{setRole(parseInt(e.target.value))}}
                            SelectProps={{
                                native: true,
                            }}      
                            style={( role === SERVICE_NUMBER) ? {width: 230,paddingRight: 16} : {width: 350,paddingRight: 16}}
                        >
                            {driverTypeList.map((item) => (
                                <option key={item.label} value={item.value}>
                                {item.label}
                                </option>
                            ))}
                        </TextField>               
                        {   
                            ( role === SERVICE_NUMBER)
                            ?
                            <TextValidator
                                id="quantity"
                                label="quantity"
                                InputLabelProps={{ shrink: true }}
                                type='number'
                                variant='outlined'
                                value={quantity}
                                onChange={(e)=>{setQuantity(e.target.value)}}
                                validators={['required', 'matchRegexp:^[1-9]{1,2}$']}
                                errorMessages={['this field is required', 'can not create between 1 to 99 at one time']}
                                style={{width: 100,paddingRight: 16}}
                            />    
                            :
                            null
                        }             
                        <TextField 
                            id="city"
                            select
                            label="city"
                            InputLabelProps={{ shrink: true }}
                            variant="outlined"
                            value={city} 
                            //disabled={role===SERVICE_NUMBER}
                            onChange={(e)=>{setCity(parseInt(e.target.value))}}
                            SelectProps={{
                                native: true,
                            }}      
                            style={{width: 166,paddingRight: 16}}
                        >
                            {cityList.map((option) => (
                                <option key={option.id} value={option.id}>
                                {option.name}
                                </option>
                            ))}
                        </TextField>      
                        <TextField 
                            id="district"
                            select
                            label="district"
                            InputLabelProps={{ shrink: true }}
                            variant="outlined"
                            value={district} 
                            //disabled={role===SERVICE_NUMBER}
                            onChange={(e)=>{setDistrict(parseInt(e.target.value))}}
                            SelectProps={{
                                native: true,
                            }}      
                            style={{width: 168,paddingRight: 16}}
                        >
                            {
                                districtList.map((item,index) => (
                                <option key={index} value={item.district_id}>
                                {item.text}
                                </option>
                                ))
                            }   
                        </TextField>                                                                                                         
                    </div>
            {
                ( role !== SERVICE_NUMBER)
                ?
                    <div style={{display: 'flex', flexDirection: 'row', paddingBottom: 16}}>               
                        <TextValidator
                            id="name"
                            label="user name"
                            InputLabelProps={{ shrink: true }}
                            type="string"
                            variant="outlined"
                            value={name}
                            disabled={(role===SERVICE_NUMBER) }
                            onChange={(e)=>{setName(e.target.value)}}
                            validators={['required', 'minStringLength:1','maxStringLength:20']}
                            errorMessages={['this field is required', 'min length is 1', 'max length is 20']}
                            style={{width: 350,paddingRight: 16}}
                        />
                        <TextField 
                            id="gender"
                            select
                            label="gender"
                            InputLabelProps={{ shrink: true }}
                            variant="outlined"
                            value={gender} 
                            disabled={role===SERVICE_NUMBER}
                            onChange={(e)=>{setGender(e.target.value)}}
                            SelectProps={{
                                native: true,
                            }}      
                            style={{width: 350,paddingRight: 16}}
                        >
                            {genderList.map((item) => (
                                <option key={item.label} value={item.value}>
                                {item.label}
                                </option>
                            ))}
                        </TextField>                       
                    </div>
                :
                null    
            }
            {
                ( role !== SERVICE_NUMBER)
                ?
                    <div style={{display: 'flex', flexDirection: 'row', paddingBottom: 16}}>                    
                        <TextValidator 
                            id="lastname"
                            label="last name"
                            InputLabelProps={{ shrink: true }}
                            type="string"
                            variant="outlined"
                            value={lastName} 
                            disabled={role===SERVICE_NUMBER}
                            onChange={(e)=>{setLastName(e.target.value)}}
                            validators={['required', 'minStringLength:1','maxStringLength:20']}
                            errorMessages={['this field is required', 'min length is 1', 'max length is 20']}
                            style={{width: 350,paddingRight: 16}}
                        />                    
                        <TextValidator 
                            id="firstname"
                            label="first name"
                            InputLabelProps={{ shrink: true }}
                            type="string"
                            variant="outlined"
                            value={firstName} 
                            disabled={role===SERVICE_NUMBER}
                            onChange={(e)=>{setFirstName(e.target.value)}}
                            validators={['required', 'minStringLength:1','maxStringLength:20']}
                            errorMessages={['this field is required', 'min length is 1', 'max length is 20']}
                            style={{width: 350,paddingRight: 16}}
                        />
                    </div>
                :
                null
            }
            {
                ( role !== SERVICE_NUMBER)
                ?
                    <div style={{display: 'flex', flexDirection: 'row', paddingBottom: 16}}>                      
                        <TextValidator
                            id="phone"
                            label="phone"
                            InputLabelProps={{ shrink: true }}
                            type='string'
                            variant='outlined'
                            value={phone}
                            disabled={role===SERVICE_NUMBER}
                            onChange={(e)=>{setPhone(e.target.value)}}
                            validators={['required', 'matchRegexp:^[0-9]{1,11}$']}
                            errorMessages={['this field is required', 'pls input the phone number in North America format']}
                            style={{width: 350,paddingRight: 16}}
                        />
                        <TextValidator 
                            id="workingarea"
                            select
                            label="working area"
                            InputLabelProps={{ shrink: true }}
                            variant="outlined"
                            value={workingArea} 
                            disabled={role===SERVICE_NUMBER}
                            onChange={(e)=>{setWorkingArea(e.target.value)}}
                            SelectProps={{
                                native: true,
                            }}                               
                            // validators={['required', 'minStringLength:1','maxStringLength:20']}
                            // errorMessages={['this field is required', 'min length is 1', 'max length is 20']}
                            style={{width: 350,paddingRight: 16}}
                        >
                            {                                
                                (role === SERVICE_NUMBER)   // if it's really driver the working area cann't be 'A' or 'B' or 'C'
                                ?
                                workingAreaList.map((item) => (
                                    <option key={item} value={item}>
                                    {item}
                                    </option>
                                ))            
                                :
                                workingAreaList.map((item) => {
                                    if (item !== 'A' && item !== 'B' && item !== 'C') {
                                        return (
                                            <option key={item} value={item}>
                                            {item}
                                            </option>        
                                        )
                                    } 
                                })            
                            }
                        </TextValidator>
                    </div>
                :
                null
            }
            {
                ( role !== SERVICE_NUMBER)
                ?
                    <div style={{display: 'flex', flexDirection: 'row', paddingBottom: 16}}>
                        <TextValidator 
                                id="sin"
                                label="SIN"
                                InputLabelProps={{ shrink: true }}
                                type="string"
                                variant="outlined"
                                value={sin} 
                                disabled={role===SERVICE_NUMBER}
                                onChange={(e)=>{setSin(e.target.value)}}                            
                                // validators={['required', 'matchRegexp:^[0-9]{9}$']}
                                validators={['required', 'matchRegexp:^[0-9]{9}$']}
                                errorMessages={['this field is required', "only number is allowed, length: 9"]}
                                style={{width: 350,paddingRight: 16}}
                            />   
                        <TextValidator 
                            id="address"
                            label="address"
                            InputLabelProps={{ shrink: true }}
                            type="string"
                            variant="outlined"
                            value={address} 
                            disabled={role===SERVICE_NUMBER}
                            onChange={(e)=>{setAddress(e.target.value)}}
                            style={{width: 350,paddingRight: 16}}
                        />                                            
                    </div>
                :
                null
            }                  
            {
                ( role !== SERVICE_NUMBER)
                ?
                    <div style={{display: 'flex', flexDirection: 'row', paddingBottom: 16}}>
                        <TextValidator 
                            id="entryTime"
                            label="entry date"
                            InputLabelProps={{ shrink: true }}
                            type="date"
                            variant="outlined"
                            value={moment.unix(entryTime).format("YYYY-MM-DD")}
                            disabled={role===SERVICE_NUMBER}
                            onChange={(e)=>{setEntryTime(moment(e.target.value + ' 00:00:00').unix())}}
                            style={{width: 350,paddingRight: 16}}
                        />
                        <TextValidator 
                            id="resignationTime"
                            label="resignate date"
                            InputLabelProps={{ shrink: true }}
                            type="date"
                            variant="outlined"
                            value={moment.unix(resignationTime).format("YYYY-MM-DD")}
                            disabled={role===SERVICE_NUMBER}
                            onChange={(e)=>{resignationTime(moment(e.target.value + ' 00:00:00').unix())}}                            
                            style={{width: 350,paddingRight: 16}}
                        />
                    </div>
                :
                null
            }
            {
                ( role !== SERVICE_NUMBER)
                ?

                    <div style={{display: 'flex', flexDirection: 'row', paddingBottom: 0}}>
                        <TextValidator 
                            id="supplies"
                            label="当前工作用品（用英文逗号隔开）"
                            InputLabelProps={{ shrink: true }}
                            type="text"
                            variant="outlined"
                            disabled = {true}
                            value={supplies} 
                            onChange={(e)=>{setSupplies(e.target.value)}}
                            style={{width: 350,paddingRight: 16}}
                        />  
                        <TextField 
                            id="bossFlg"
                            select
                            label="authority(0=default,1=scan allowed)"
                            InputLabelProps={{ shrink: true }}
                            variant="outlined"
                            value={bossFlg} 
                            disabled={role===SERVICE_NUMBER}
                            onChange={(e)=>{setBossFlg(e.target.value)}}
                            SelectProps={{
                                native: true,
                            }}      
                            style={{width: 350,paddingRight: 16}}
                        >
                            {bossFlgList.map((option) => (
                                <option key={option.value} value={option.value}>
                                {option.label}
                                </option>
                            ))}
                        </TextField>                           
                    </div>
                :
                null
            }                    
            {
                ( role !== SERVICE_NUMBER)
                ?

                    <div style={{display: 'flex', flexDirection: 'row', paddingBottom: 16}}>
                        <button variant="contained" color="primary" disabled={role===SERVICE_NUMBER} onClick={(e)=>handleSuppliesClick("反光衣",e)}>反光衣</button>
                        <button variant="contained" color="primary" disabled={role===SERVICE_NUMBER} onClick={(e)=>handleSuppliesClick("帽子",e)}>帽子</button>
                        <button variant="contained" color="primary" disabled={role===SERVICE_NUMBER} onClick={(e)=>handleSuppliesClick("车贴",e)}>车贴</button>
                        <button variant="contained" color="primary" disabled={role===SERVICE_NUMBER} onClick={(e)=>handleSuppliesClick("保温箱",e)}>保温箱</button>
                    </div>        
                :
                null
            }    
            {
                ( role !== SERVICE_NUMBER)
                ?                                                              
                    <div style={{display: 'flex', flexDirection: 'row'}}>
                        <FormControl component="fieldset" className={classes.formControl} style={{width: 350,paddingRight: 16}}>
                            <FormLabel >分组</FormLabel>
                            <FormGroup >
                                {
                                    driverGroupState.map((item,index)=>(
                                        <FormControlLabel key={index}
                                            control={<Checkbox 
                                                    checked={item.checked} 
                                                    name={"status"}
                                                    disabled={role!==SELF_EMPLOYEE_DRIVER} 
                                                    onChange={(e)=>{setDriverGroupState(driverGroupState.map((ele,idx)=>idx===index? 
                                                        {...ele, checked: e.target.checked}:
                                                        ele)
                                                    )}}                                                      
                                                />}
                                            label={item.label}
                                        />                                        
                                    ))
                                }

                            </FormGroup>
                        </FormControl>
                        <FormControl component="fieldset" className={classes.formControl} style={{width: 350,paddingRight: 16}}>
                            <FormLabel component="legend">salary type</FormLabel>
                            <FormGroup > 
                            {
                                driverSalaryTypeState.map((item,index)=>{
                                    if (item.label==="FIX" && item.checked === true) {
                                        return(
                                            <React.Fragment key={index}>
                                            <FormControlLabel key={index}
                                            control={<Checkbox 
                                                    checked={item.checked} 
                                                    name={"status"}
                                                    disabled={role!==SELF_EMPLOYEE_DRIVER} 
                                                    onChange={(e)=>{setDriverSalaryTypeState(driverSalaryTypeState.map((ele,idx)=>idx===index? 
                                                        {...ele, checked: e.target.checked}:
                                                        ele)
                                                    )}}                                                      
                                                />}
                                            label={item.label}
                                            >                                                
                                            </FormControlLabel>
                                            <TextField key={index}
                                                 id="salaryTypeFix"
                                                 select
                                                 label="please select"
                                                 InputLabelProps={{ shrink: true }}
                                                 variant="outlined"
                                                 value={salaryTypeFix} 
                                                 disabled={role!==SELF_EMPLOYEE_DRIVER} 
                                                 onChange={(e)=>{setSalaryTypeFix(parseInt(e.target.value))}}
                                                 SelectProps={{
                                                     native: true,
                                                 }}      
                                                 style={{width: 250}}
                                             >
                                             {
                                                 salaryTypeFixList.map((item) => (
                                                     <option key={item.value} value={item.value}>
                                                     {item.label}
                                                     </option>
                                                 ))
                                             }
                                            </TextField>
                                            </React.Fragment>
                                        )    
                                    } else {
                                        return(
                                            <FormControlLabel key={index}
                                            control={<Checkbox 
                                                    checked={item.checked} 
                                                    name={"status"}
                                                    disabled={role!==SELF_EMPLOYEE_DRIVER} 
                                                    onChange={(e)=>{setDriverSalaryTypeState(driverSalaryTypeState.map((ele,idx)=>idx===index? 
                                                        {...ele, checked: e.target.checked}:
                                                        ele)
                                                    )}}                                                      
                                                />}
                                            label={item.label}
                                            />                                                
                                        )    
                                    }

                                })
                            }
                            </FormGroup>
                        </FormControl>    
                    </div>      
                :
                null
            }
                </DialogContent>
                <DialogActions >
                    <Button type="submit" variant="contained" color='default' disabled={isSubmitted} >Save</Button>           
                </DialogActions>     
            </ValidatorForm>
            {
                msgShow ?
                <MessageSnackbar openModal={msgShow} vertical={'top'} horizontal={'right'} msgLevel={msgLevel} msgContent={msgContent} onClose={handleCloseMessageSnackbar}/>
                : null
            }
            
            </Dialog>
    )

    /**
     * Close the MessageSnackbar
     * Call the prarent function to handle the status after this dialoge is closed
     */
    function handleClose() {    
        setMsgShow(false);  
        onAddClose();
    };

    /**
     * handle the suppies, using ',' to seperate the items
     * @param {*} content 
     * @param {*} e 
     */
    function handleSuppliesClick(content,e) { 

        let current_supply_str = supplies;
        let supplies_arr = current_supply_str.split(',').map(a => a.trim()).filter(a => a);
        if (supplies_arr.includes(content)) {
            supplies_arr = supplies_arr.filter(a => a !== content);
        } else {
            supplies_arr.push(content);
        }
        setSupplies(supplies_arr.join(','));        

        e.preventDefault();
    }

    /**
     * set the fields before and post the save message to the backend 
     */
    function handleAddDriverInfo() {   
        preventFrequentPost();

        if (role === SERVICE_NUMBER) {
            dispatch(addSystemDrivers({city: city,district: district,number: quantity}));
        } else {
            let params = assembleParams();
            dispatch(addDriverInfo(params));
        }        
    }

    /**
     * assemable params
     */
    function assembleParams() {
        //determine the mulitipule group info
        let groupArr = [];
        driverGroupState.map((item)=>{
            if (item.checked === true) groupArr.push(item.id) ;
            return groupArr;
        });

        //when the salary type is "FIX" the specific fix value should be determined
        let salaryTypeArr = [];
        if (role === SELF_EMPLOYEE_DRIVER) {
            driverSalaryTypeState.map((item)=>{
                if (item.label === "FIX" && (item.checked === true) ) {
                    salaryTypeArr.push(salaryTypeFix);
                } else if (item.label !== "FIX" && (item.checked === true)) {
                    salaryTypeArr.push(item.id);
                }
            })    
        } 

        let params = {
            role: role,
            city_id: city,
            district: district,
            name: name,
            gender:gender,
            lastname: lastName,
            firstname: firstName,
            phone: phone,
            workingarea: workingArea,
            sin: sin,
            address : address,
            entry_time: entryTime,
            resignation_time: resignationTime,
            supplies: supplies,
            bossflg: bossFlg,
            group: groupArr,
            salary_type: salaryTypeArr,
            //Todo: need to be determined later
            is_hired: isHired,
            role_desc: roleDesc,
            devicetoken: devicetoken,

            // API need currently, need to be determined later .....
            password: "777", 
            workingstatus: 0,
            username : name,            
            level : 1,     
            resignation_time:0,
        } ;

        return params;
    }

    /**
     * set the sepcific level and message and notify user the action result
     * @param {*} msgShow 
     * @param {*} msgLevel 
     * @param {*} msgContent 
     */
    function showMessageSnackbar(msgShow,msgLevel,msgContent) {
        setMsgShow(msgShow);
        setMsgLevel(msgLevel);
        setMsgContent(msgContent);
    }

    /**
     * close the componet "MessageSnackbar" 
     */
    function handleCloseMessageSnackbar() {
        setMsgShow(false);  
    }

    /**
     * to prevent the frequent post which may cause the unnecessary database burden, the user could only repost after 1 second
     */
    function preventFrequentPost() {
        setIsSubmitted(true, 
            setTimeout(() => setIsSubmitted(false), 1000)
        );    
    }
}

//export default AddDriverInfo
export default React.memo(AddDriverInfo)
